import { useEffect, useState } from "react";
import { Wrench, Save, MailWarning, MailCheck } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const UserSelect = ({ label, value, onChange, users, testid }) => (
  <div className="space-y-1.5">
    <Label>{label}</Label>
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="—" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Nessuno</SelectItem>
        {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}{u.email ? ` · ${u.email}` : ""}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export default function ResponsabiliSettings() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ ticket_user_id: "", manutenzione_user_id: "" });
  const [smtp, setSmtp] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/users").then((r) => setUsers((r.data || []).filter((u) => u.role !== "tecnico"))).catch(() => {});
    api.get("/settings/responsabili").then((r) => { setForm({ ticket_user_id: r.data.ticket_user_id, manutenzione_user_id: r.data.manutenzione_user_id }); setSmtp(r.data.smtp_configured); }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings/responsabili", form);
      setSmtp(data.smtp_configured);
      toast.success("Responsabili aggiornati");
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <div className="rounded-xl border border-border bg-card p-6" data-testid="responsabili-settings">
      <div className="mb-1 flex items-center gap-2"><Wrench size={18} className="text-primary" /><h3 className="font-bold text-navy">Responsabili Delivery e Manutenzione</h3></div>
      <p className="mb-4 text-sm text-muted-foreground">Ricevono una mail quando un ticket passa sotto la loro gestione: il responsabile Manutenzione (Ticket - Manutenzione) quando arriva una copia, il responsabile Delivery (Ticket e Pianificazione - Delivery & Assurance) quando la manutenzione è completata.</p>
      <div className="grid gap-4 sm:grid-cols-2">
        <UserSelect label="Responsabile Delivery" value={form.ticket_user_id} onChange={(v) => setForm((f) => ({ ...f, ticket_user_id: v }))} users={users} testid="resp-ticket-select" />
        <UserSelect label="Responsabile Manutenzione" value={form.manutenzione_user_id} onChange={(v) => setForm((f) => ({ ...f, manutenzione_user_id: v }))} users={users} testid="resp-mnt-select" />
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <Button onClick={save} disabled={saving} data-testid="resp-save"><Save size={16} />Salva</Button>
        {smtp ? (
          <span className="flex items-center gap-1.5 text-xs font-semibold text-emerald-700" data-testid="smtp-status"><MailCheck size={14} />Casella di posta configurata</span>
        ) : (
          <span className="flex items-center gap-1.5 text-xs font-semibold text-amber-700" data-testid="smtp-status"><MailWarning size={14} />Casella di posta non ancora configurata: le mail non vengono inviate</span>
        )}
      </div>
    </div>
  );
}
